Vendd.Scripts.load(function () {
    var $wrapper = $('.x-login-widget');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null, loaded = false;

    wrapper.open = function () {
        $('.js-widget-trigger', $wrapper).addClass('x-open');
        $('.js-widget-container', $wrapper).addClass('x-expanded');

        if (!recaptchaLoaded) wrapper.appendRecaptcha();
     
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.LoginWidget));
    };

    wrapper.close = function () {
        $('.js-widget-trigger', $wrapper).removeClass('x-open');
        $('.js-widget-container', $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.minimalUpdate = function () {
        var html = Vendd.Handlebars.parse("loginWidget_B", model);
        $wrapper.html(html);

        if (loaded) loaded = false;
    };

    wrapper.update = function () {
        wrapper.loading(true);
        var html = Vendd.Handlebars.parse("loginWidgetBox_A", model);
        $('.js-widget-container', $wrapper).html(html);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));
        wrapper.loading(false);
    };

    wrapper.appendRecaptcha = function () {
        var url = 'https://www.google.com/recaptcha/api.js?onload=callback_recaptcha&render=explicit&hl=' + LhApp.Context.Language;
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.getElementsByTagName('body')[0].appendChild(script);
    };

    $wrapper.on('click', '.js-logout', function (e) {
        e.preventDefault();

        Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
    });
   
    //On click Login Button
    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        if (model === null) return;

        if ($(this).hasClass('x-open')) {
            $('.header-overlay').removeClass('visible');
            $('.header-region').removeClass('clean-zindex');
            $('html, body').removeClass('no-scroll');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.close();
        } else {
            if (!loaded) {
                wrapper.update();
                loaded = true;
            }
            $('html, body').addClass('no-scroll');
            if ($('.header-region').hasClass('sticky')) {
                $('.header-spacer').height(0);
                $('.header-region').removeClass('sticky');
            }
            $('.header-region').addClass('clean-zindex');
            $('.header-overlay').addClass('visible');
            $('.js-widget-container', $wrapper).addClass('animation');
            wrapper.loading(false);
            wrapper.open();
        }
    });

    //On click Close Button inside Login Widget
    $wrapper.on('click', '.close-button', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    //On click outside Login Widget
    $('.header-overlay').on('click', function (e) {
        e.preventDefault();

        $('.header-overlay').removeClass('visible');
        $('.header-region').removeClass('clean-zindex');
        $('html, body').removeClass('no-scroll');
        $('.js-widget-container', $wrapper).addClass('animation');
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, wrapper, function (envelope) {
        if (envelope.message.data.success) {
            $('.header-overlay').removeClass('visible');
            $('.header-region').removeClass('clean-zindex');
            $('html, body').removeClass('no-scroll');
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, wrapper, function (envelope) {
        if (envelope.message.data.success) {
            Vendd.MessageBus.publish(wrapper, new Vendd.User.Messages.GetUserViewModel());
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.LoginWidget) {
            wrapper.close();
        }
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;

        wrapper.minimalUpdate();

        if (loaded) wrapper.update();  
        if ($wrapper.hasClass('x-loading')) $('.js-widget-trigger', $wrapper).trigger("click");
    });

});